/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import clsx from "clsx";
import { Link, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import phoneFormat from "../../../../helpers/phoneFormat";
import onlyNumber from "../../../../helpers/onlyNumber";
import { register } from "../../../../components/layout/auth/core/_requests";
import { PasswordMeterComponent } from "../../../../../_metronic/assets/ts/components";
import {
  URL_AUTH_JSHIR_REGISTER,
  URL_AUTH_JSHIR_REGISTER_INFO,
  URL_AUTH_LOGIN,
  URL_AUTH_REGISTER_CONFIRM,
} from "../../../../mock/page_urls";

const initialValues = {
  jshir: "11111111111111",
  phone: "+998 92 123-45-67",
  password: "12345678a",
  changepassword: "12345678a",
};

const registrationSchema = Yup.object().shape({
  jshir: Yup.string().length(14, "Bu JSHIR emas").required("JSHIR majburiy"),
  phone: Yup.string()
    .length(17, "Telefon raqam emas")
    .required("Telefon raqam majburiy"),
  password: Yup.string()
    .min(8, "Minimal 8 ta belgi")
    .matches(/[0-9]/, "Kamida bitta raqam bo‘lishi majburiy")
    .matches(/[a-z]/, "Kamida bitta kichkina harf bo‘lishi majburiy")
    .required("Parol majburiy"),
  changepassword: Yup.string()
    .min(3, "Minimal 3 ta belg")
    .required("Parolni Tasdiqlash majburiy")
    .oneOf([Yup.ref("password")], "Parol yuqoridagi bilan mos emas"),
});

export function Info() {
  const [loading, setLoading] = useState(false);
  const intl = useIntl();
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, { setSubmitting, setErrors, setFieldError }) => {
      setLoading(true);
      try {
        const { data: auth } = await register(
          values.jshir,
          onlyNumber(values.phone),
          values.password,
          values.changepassword
        );
        setLoading(false);
        setSubmitting(false);
        navigate(`/auth${URL_AUTH_REGISTER_CONFIRM}`);
        sessionStorage.setItem(
          "flx_register_phone_confirm",
          onlyNumber(values.phone)
        );
      } catch (error: any) {
        if ((error.response as any) && error.response.data) {
          setErrors(error.response.data);
          setSubmitting(false);
        }
        if ((error.response as any) && error.response.data.error_code == 4009) {
          setFieldError("jshir", error.response.data.message);
          setSubmitting(false);
          setTimeout(() => {
            navigate(`/auth${URL_AUTH_JSHIR_REGISTER_INFO}`);
          }, 5000);
        }
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    PasswordMeterComponent.bootstrap();
  }, []);

  return (
    <form
      className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
      noValidate
      id="kt_login_signup_form"
      onSubmit={formik.handleSubmit}
    >
      {/* begin::Heading */}
      <div className="text-center mb-11">
        {/* begin::Title */}
        <h1 className="text-dark fw-bolder mb-3">
          {intl.formatMessage({ id: "Ro’yhatdan o’tish" })}
        </h1>
        {/* end::Title */}

        <div className="text-gray-500 fw-semibold fs-6">
          {intl.formatMessage({
            id: "Ro’yhatdan o’tish uchun ma’lumotlarni to’ldiring",
          })}
        </div>
      </div>
      {/* end::Heading */}

      {/* {formik.status && (
        <div className="mb-lg-15 alert alert-danger">
          <div className="alert-text font-weight-bold">{formik.status}</div>
        </div>
      )} */}

      {/* begin::Form group jshir */}
      <div className="fv-row mb-8">
        <label className="form-label fw-bolder text-dark fs-6">JSHIR</label>
        <input
          placeholder="JSHIR"
          type="text"
          autoComplete="off"
          {...formik.getFieldProps("jshir")}
          className={clsx(
            "form-control bg-transparent",
            {
              "is-invalid": formik.touched.jshir && formik.errors.jshir,
            },
            {
              "is-valid": formik.touched.jshir && !formik.errors.jshir,
            }
          )}
        />
        {formik.touched.jshir && formik.errors.jshir && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <span role="alert">{formik.errors.jshir}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}
      <div className="fv-row mb-8">
        {/* begin::Form group phone */}
        <label className="form-label fw-bolder text-dark fs-6">
          {intl.formatMessage({ id: "Telefon raqam" })}
        </label>
        <input
          placeholder={intl.formatMessage({
            id: "Telefon raqamingizni kiriting",
          })}
          type="text"
          autoComplete="off"
          {...formik.getFieldProps("phone")}
          onChange={(e) =>
            formik.setFieldValue("phone", phoneFormat(e.target.value))
          }
          className={clsx(
            "form-control bg-transparent",
            {
              "is-invalid": formik.touched.phone && formik.errors.phone,
            },
            {
              "is-valid": formik.touched.phone && !formik.errors.phone,
            }
          )}
        />
        {formik.touched.phone && formik.errors.phone && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <span role="alert">{formik.errors.phone}</span>
            </div>
          </div>
        )}
        {/* end::Form group */}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Password */}
      <div className="fv-row mb-8" data-kt-password-meter="true">
        <div className="mb-1">
          <label className="form-label fw-bolder text-dark fs-6">
            {intl.formatMessage({ id: "Parol" })}
          </label>
          <div className="position-relative mb-3">
            <input
              type="password"
              placeholder={intl.formatMessage({ id: "Parol o'ylab toping" })}
              autoComplete="off"
              {...formik.getFieldProps("password")}
              className={clsx(
                "form-control bg-transparent",
                {
                  "is-invalid":
                    formik.touched.password && formik.errors.password,
                },
                {
                  "is-valid":
                    formik.touched.password && !formik.errors.password,
                }
              )}
            />
            {formik.touched.password && formik.errors.password && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">
                  <span role="alert">{formik.errors.password}</span>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="text-muted">
          {intl.formatMessage({
            id: "8 yoki undan ko'p belgilar bilan foydalaning, harflar, raqamlar va belgilar aralashmasi bilan.",
          })}
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group Confirm password */}
      <div className="fv-row mb-5">
        <label className="form-label fw-bolder text-dark fs-6">
          {intl.formatMessage({ id: "Parolni qayta kiriting" })}
        </label>
        <input
          type="password"
          placeholder={intl.formatMessage({ id: "Parolni qayta kiriting" })}
          autoComplete="off"
          {...formik.getFieldProps("changepassword")}
          className={clsx(
            "form-control bg-transparent",
            {
              "is-invalid":
                formik.touched.changepassword && formik.errors.changepassword,
            },
            {
              "is-valid":
                formik.touched.changepassword && !formik.errors.changepassword,
            }
          )}
        />
        {formik.touched.changepassword && formik.errors.changepassword && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <span role="alert">{formik.errors.changepassword}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className="text-center">
        <button
          type="submit"
          id="kt_sign_up_submit"
          className="btn btn-lg btn-primary w-100 mb-5"
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && (
            <span className="indicator-label">
              {intl.formatMessage({ id: "Ro'yhatdan o'tish" })}
            </span>
          )}
          {loading && (
            <span className="indicator-progress" style={{ display: "block" }}>
              {intl.formatMessage({ id: "Iltimos kuting..." })}{" "}
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Form group */}

      <div className="text-gray-500 text-center fw-semibold fs-5">
        {intl.formatMessage({ id: "JSHIR topilmadimi?" })}{" "}
        <Link
          to={`/auth${URL_AUTH_JSHIR_REGISTER_INFO}`}
          className="link-primary"
        >
          {intl.formatMessage({ id: "erp.maktab.uz siz ro'yhatdan o'tish" })}
        </Link>
      </div>
      <div className="text-gray-500 text-center fw-semibold fs-5">
        {intl.formatMessage({ id: "Akkauntingiz bormi?" })}{" "}
        <Link to={`/auth${URL_AUTH_LOGIN}`} className="link-primary">
          {intl.formatMessage({ id: "Kirish" })}
        </Link>
      </div>
    </form>
  );
}
